import React from 'react';
import './App.css'

export const Footer = () => {
  return (
    <div>
        <div className='footerbg mt-5'>
              <h1 className='footertxt text-center pt-3'>McLaren</h1>
              <div className='d-flex justify-content-between pt-2'>
                <h6 className='footertxttwo ps-3 '>Copyrights@mcl/2023</h6>
                <h6 className='footertxttwo pe-3 '>All Rights Reserved</h6>
              </div>
        </div>
    </div>
  )
}
